import { ForeignStaffTravelSummary } from '../../lib/types/models/affectedStaff/foreign-staff-travel-summary'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getForeignStaffTravelSummary(id: number): Promise<ForeignStaffTravelSummary> {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.getForeignTravelSummary.url, { id }))
    .get<ForeignStaffTravelSummary>()
}
